const initialState = {
    trans: [],
};
const wallet = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_WALLET':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default wallet;
